
import { Component, Prop, Vue } from 'vue-property-decorator';

export type DisconnectResourceType = 'page' | 'location';

@Component({ name: 'platform-disconnect-row' })
export default class PlatformDisconnectRow extends Vue {
  @Prop({ required: true, type: String })
  readonly buttonLabel!: string;

  @Prop({ required: false, type: String, default: 'page' })
  readonly resourceType!: DisconnectResourceType;

  @Prop({ required: false, type: Boolean, default: false })
  readonly loading!: boolean;

  get warningText(): string {
    return `This will remove the connection to your ${this.resourceType}. You can reconnect at any time.`;
  }
}
